import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.181 8.69a4.503 4.503 0 0 1 1.903 6.405m-9.768-2.782L3.559 14.07a4.5 4.5 0 0 0 6.364 6.365l3.129-3.13m5.614-5.614 1.757-1.757a4.5 4.5 0 0 0-6.364-6.365l-4.5 4.5q-.387.39-.661.84m1.903 6.405a4.5 4.5 0 0 1-1.242-.88 4.5 4.5 0 0 1-1.062-1.684m6.587 2.345 5.907 5.908m-5.907-5.908L8.898 8.908M2.99 3.002 8.897 8.91"
    }, null, -1)
  ])))
}
export default { render: render }